import { Title } from "@common/index";

// TODO(legal): real copy required pre-launch per Q13
export const TermsPage = () => {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10 text-primary">
            <Title>Terms and Conditions</Title>
            <div role="alert" className="alert alert-warning mt-6">
                <span>
                    ⚠️ This is placeholder copy. Real Terms will be in place
                    before public launch.
                </span>
            </div>
            <p className="text-base mt-6">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
        </div>
    );
};
